import React from 'react'
import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'

const ProductDetailSkeleton = () => {
  const products = [1, 2, 3, 4]
  const productRow = [1, 2]
  return (
    <Wrapper>
      <ProductContent>
        <Skeleton width="100%" height="calc(100vw - 70px)" borderRadius={10} />
        <ProductName>
          <Skeleton height={25} width={170} />
          <Skeleton height={50} width={280} borderRadius={100} />
        </ProductName>
      </ProductContent>
      <ProductsOthers>
        <Header>
          <BrandWrapper>
            <Skeleton width={30} height={30} circle />
            <Skeleton width={175} height={25} />
          </BrandWrapper>
          <DetailsWrapper>
            <LocationDesc>
              <Skeleton width={130} height={25} />
              <Skeleton width={30} height={25} />
            </LocationDesc>
          </DetailsWrapper>
        </Header>
        <ProducList>
          {products.map((product) => (
            <ProductRow key={product}>
              {productRow.map((row) => (
                <ProductItem key={row}>
                  <ProductThumbnail height={`calc(52vw - 38px)`} borderRadius={5} />
                  <ProductDetail>
                    <Skeleton width={100} height={25} borderRadius={5} />
                    <Skeleton width={40} height={40} borderRadius={20} />
                  </ProductDetail>
                </ProductItem>
              ))}
            </ProductRow>
          ))}
        </ProducList>
      </ProductsOthers>
    </Wrapper>
  )
}

export default ProductDetailSkeleton

const Wrapper = styled.div`
  padding: 15px;
`

const ProductContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 5px;
  padding-top: 30px;
`

const ProductName = styled.div`
  width: 100%;
  padding-top: 30px;
  row-gap: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ProductsOthers = styled.div``

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  column-gap: 15px;
`

const BrandWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`

const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const LocationDesc = styled.div`
  display: flex;
  align-items: center;
  column-gap: 5px;
  width: 75vw;
  color: ${({ theme }) => theme.colors.darkGrey};
`

const ProducList = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  padding-top: 15px;
`

const ProductRow = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 15px;
`

const ProductItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px;
  row-gap: 8px;
  width: 48%;
`
const ProductDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ProductThumbnail = styled(Skeleton)`
  width: 100%;
`
